import React, { FC, ReactElement, memo } from 'react';
// Components
import RoundedIcon from '../icons/roundedIcon';
import ReservationLabelInfos from '../reservations/reservationLabelInfos';
// Resources
import { BaseUser } from '../../core/apiTypes';
import { IconAxel } from '../../resources/images';
import { getFullnameMaxed } from '../../utils/user';

interface PassengerListProps {
    passengers: BaseUser[];
    pro: boolean;
    onEdit?: () => void;
}

const PassengersList: FC<PassengerListProps> = (props): ReactElement => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { passengers, pro, onEdit } = props;

    const renderPassengersInfos = (dataEntries): JSX.Element[] => {
        if (dataEntries?.length) {
            return dataEntries.map((rider: BaseUser): JSX.Element => {
                return (
                    <ReservationLabelInfos
                        key={rider.id}
                        iconElement={<RoundedIcon customBackground="grey" icon={IconAxel.User} size="small" />}
                        label={getFullnameMaxed(rider)} // stringsRes.reservation.passenger
                        alwaysVisible
                        // avatarValue={pro ? null : stringsRes.common.perso}
                        onEdit={onEdit}
                    />
                );
            });
        }
        return null;
    };
    return <>{renderPassengersInfos(passengers)}</>;
};

export default memo(PassengersList);
